export const translations = {
  fr: {
    nav: {
      home: "Accueil",
      about: "À propos",
      services: "Services",
      projects: "Projets",
      gallery: "Galerie",
      news: "Actualités",
      blog: "Blog",
      partners: "Partenaires",
      contact: "Contact",
    },
    partners_section: {
      title: "Nos Partenaires",
      subtitle: "Des collaborations solides avec des institutions de premier plan",
    },
    hero: {
      overline: "Ingénierie — Construction — Consulting",
      slogan: "Le g\u00e9nie au service de vos ambitions",
      subtext: "Conception, construction et supervision d'infrastructures critiques en République Démocratique du Congo. Génie civil, forage hydraulique, électrification et consulting technique aux standards internationaux.",
      cta_services: "Découvrir nos services",
      cta_contact: "Demander un devis",
      stats: {
        projects: "Projets livrés",
        experience: "Ans d'expérience",
        engineers: "Ingénieurs & techniciens",
        provinces: "Provinces couvertes",
      },
    },
    about: {
      title: "À Propos",
      subtitle: "Depuis 2009, nous bâtissons l'infrastructure de demain",
      history: {
        title: "Notre Histoire",
        p1: "Fondée en 2009 à Kananga, JKM Engineering Sarl est née de la vision d'ingénieurs congolais déterminés à offrir des solutions techniques de classe mondiale sur le territoire national. Ce qui a commencé comme un bureau d'études spécialisé en génie civil s'est rapidement développé pour devenir l'une des entreprises d'ingénierie les plus complètes de la RDC.",
        p2: "En 15 ans, nous avons livré plus de 50 projets d'envergure — des ponts aux réseaux d'adduction d'eau, des bâtiments institutionnels aux systèmes d'assainissement — couvrant l'ensemble du territoire congolais. Notre croissance repose sur un principe simple : chaque projet est une opportunité de démontrer que l'expertise locale peut rivaliser avec les standards internationaux.",
      },
      mission: {
        title: "Mission",
        text: "Concevoir et réaliser des infrastructures durables qui transforment les conditions de vie des communautés congolaises, en combinant expertise technique de pointe, innovation technologique et engagement envers l'excellence opérationnelle.",
      },
      vision: {
        title: "Vision",
        text: "Devenir le partenaire de référence en ingénierie en Afrique centrale, reconnu pour la qualité irréprochable de nos ouvrages, notre capacité d'innovation et notre impact mesurable sur le développement des infrastructures du continent.",
      },
      values: {
        title: "Nos Valeurs",
        quality: "Excellence",
        quality_desc: "Standards ISO 9001 appliqués à chaque phase de projet, du dimensionnement à la réception des ouvrages",
        innovation: "Innovation",
        innovation_desc: "Intégration de technologies modernes — drone topographique, BIM, analyse géotechnique avancée",
        reliability: "Fiabilité",
        reliability_desc: "Respect systématique des délais contractuels avec un taux de livraison à l'heure de 94%",
        integrity: "Intégrité",
        integrity_desc: "Gouvernance transparente, reporting régulier aux parties prenantes, conformité réglementaire totale",
      },
      team: {
        title: "Équipe Dirigeante",
        members: [
          { name: "Ir. Jean-Kasongo Mutombo", role: "Directeur Général & Ingénieur Principal", desc: "Ingénieur Civil (Université de Kinshasa), 20+ ans d'expérience en génie civil et gestion de grands projets" },
          { name: "Ir. Patrick Kalombo", role: "Directeur Technique", desc: "Spécialiste en hydrogéologie et forage profond, certifié IWRA" },
          { name: "Ir. Marie Tshilumba", role: "Responsable Qualité & HSE", desc: "Ingénieur Qualité certifiée ISO 9001:2015 & ISO 45001, experte en systèmes de management intégré" },
        ],
      },
      certifications: {
        title: "Certifications & Standards",
        items: ["ISO 9001:2015 — Système de Management de la Qualité", "ISO 45001:2018 — Santé et Sécurité au Travail", "Eurocodes — Calcul des structures", "ASTM International — Essais matériaux", "RCCM : CD/KGA/RCCM/24-B-00015"],
      },
      methodology: {
        title: "Méthodologie de Travail",
        steps: [
          { step: "01", title: "Études Préliminaires", desc: "Reconnaissance terrain, étude de faisabilité, analyse géotechnique" },
          { step: "02", title: "Conception & Dimensionnement", desc: "Plans techniques, calculs structurels (Eurocodes), modélisation BIM" },
          { step: "03", title: "Exécution & Supervision", desc: "Gestion de chantier, contrôle qualité permanent, reporting hebdomadaire" },
          { step: "04", title: "Réception & Suivi", desc: "Tests de conformité, formation du client, garantie post-livraison" },
        ],
      },
      legal: {
        title: "Informations Légales",
        address: "Adresse",
        rccm: "RCCM",
        national_id: "ID National",
        tax_number: "N° Impôt",
      },
    },
    services: {
      title: "Nos Services",
      subtitle: "Solutions d'ingénierie intégrées aux standards internationaux",
      intro: "Six pôles d'expertise pour couvrir l'intégralité du cycle de vie de vos projets d'infrastructure, de la conception à la maintenance.",
      civil: {
        title: "Génie Civil & Structures",
        desc: "Conception et construction de structures en béton armé, charpentes métalliques et ouvrages d'art conformes aux Eurocodes et normes ACI 318.",
        items: ["Bâtiments institutionnels et résidentiels", "Ponts et ouvrages d'art", "Murs de soutènement et gabions", "Routes et voiries urbaines", "Ouvrages d'assainissement et dalots"],
        standards: "Eurocodes, ACI 318, NF EN 1992",
        process: "Études géotechniques → Dimensionnement → Plans d'exécution → Construction → Contrôle qualité → Réception",
      },
      electrical: {
        title: "Génie Électrique & Énergie",
        desc: "Installation de systèmes électriques et solutions d'énergie renouvelable pour sites isolés et bâtiments — kits solaires photovoltaïques, distribution basse/moyenne tension.",
        items: ["Systèmes solaires photovoltaïques (off-grid & hybride)", "Distribution électrique basse et moyenne tension", "Éclairage public et signalisation", "Groupes électrogènes et onduleurs", "Audit énergétique et optimisation"],
        standards: "IEC 60364, NF C 15-100, IEEE",
        process: "Audit énergétique → Dimensionnement → Approvisionnement → Installation → Tests & mise en service",
      },
      topography: {
        title: "Topographie & Géomatique",
        desc: "Levés topographiques de précision par GPS RTK et drone, modélisation numérique de terrain (MNT), cartographie SIG pour la planification d'infrastructures.",
        items: ["Levés topographiques GPS RTK", "Photogrammétrie par drone", "Modèles numériques de terrain (MNT/MNS)", "Cartographie SIG et plans cadastraux", "Implantation et piquetage de chantier"],
        standards: "ISO 19111, GNSS RTK, WGS 84",
        process: "Reconnaissance → Acquisition de données → Traitement → Modélisation → Livraison plans",
      },
      drilling: {
        title: "Forage & Hydraulique",
        desc: "Forage profond (jusqu'à 250 m) pour l'approvisionnement en eau potable des communautés rurales et périurbaines, avec pompage solaire et gestion durable des ressources en eau.",
        items: ["Forage rotatif et marteau fond de trou (MFT)", "Pompage d'essai et caractérisation d'aquifère", "Équipement de pompage solaire", "Réseaux d'adduction d'eau potable", "Hydraulique villageoise et périurbaine"],
        standards: "ISO 22475, ASTM D5092, Normes OMS eau potable",
        process: "Étude hydrogéologique → Implantation → Forage → Pompage d'essai → Équipement → Mise en service",
      },
      construction: {
        title: "Construction & BTP",
        desc: "Réalisation de projets de construction clé en main — du terrassement à la finition — avec une gestion rigoureuse des coûts, délais et qualité selon les meilleures pratiques FIDIC.",
        items: ["Construction de bâtiments clé en main", "Terrassement et travaux de fondation", "Pavage en autobloquants et revêtements", "Aménagement paysager et espaces verts", "Réhabilitation et rénovation de structures"],
        standards: "FIDIC, DTU, Règles NV 65",
        process: "APD → Plans d'exécution → Approvisionnement → Construction → Contrôle qualité → Réception provisoire → Réception définitive",
      },
      consulting: {
        title: "Consulting & Gestion de Projets",
        desc: "Accompagnement technique et stratégique des maîtres d'ouvrage — études de faisabilité, montage de dossiers techniques, supervision de chantier et évaluation post-projet.",
        items: ["Études de faisabilité technique et économique", "Montage de dossiers techniques d'appels d'offres", "Maîtrise d'œuvre et supervision de chantier", "Audits techniques et diagnostics structurels", "Formation et transfert de compétences"],
        standards: "FIDIC, PMI/PMBOK, Prince2",
        process: "Cadrage → Diagnostic → Recommandations → Plan d'action → Mise en œuvre → Évaluation",
      },
    },
    projects: {
      title: "Nos Réalisations",
      subtitle: "Un portefeuille de projets d'infrastructure qui démontrent notre savoir-faire",
      view_details: "Voir les détails",
      budget: "Budget",
      duration: "Durée",
      tech: "Technologies",
      challenge: "Défi technique",
      result: "Résultat",
    },
    gallery: {
      label: "Galerie",
      title: "Nos Chantiers en Images",
      subtitle: "Documentation photographique de nos réalisations sur le terrain. Cliquez pour agrandir.",
    },
    news: {
      title: "Actualités",
      subtitle: "Les dernières avancées de JKM Engineering en RDC",
      read_more: "Lire la suite",
      all_news: "Toutes les actualités",
      latest: "Récent",
    },
    blog: {
      title: "Blog Technique",
      subtitle: "Analyses approfondies et réflexions sur l'ingénierie en Afrique",
      read_more: "Lire l'article complet",
    },
    why: {
      title: "Pourquoi JKM Engineering",
      subtitle: "L'excellence qui fait la différence",
      experience: "Ans d'expérience",
      projects: "Projets livrés",
      clients: "Satisfaction client",
      partners: {
        title: "Nos Partenaires",
        desc: "Nous collaborons avec des institutions de premier plan",
      },
    },
    testimonials: {
      title: "Témoignages",
      subtitle: "Ce que disent nos clients et partenaires",
    },
    contact: {
      title: "Contactez-Nous",
      subtitle: "Discutons de votre prochain projet d'infrastructure",
      form: {
        name: "Nom complet",
        email: "Email professionnel",
        phone: "Téléphone",
        company: "Organisation / Entreprise",
        service: "Service souhaité",
        service_options: {
          placeholder: "Sélectionner un service",
          civil: "Génie Civil & Structures",
          electrical: "Génie Électrique & Énergie",
          topography: "Topographie & Géomatique",
          drilling: "Forage & Hydraulique",
          construction: "Construction & BTP",
          consulting: "Consulting & Gestion de Projets",
        },
        budget: "Budget estimé (USD)",
        budget_options: {
          placeholder: "Sélectionner une fourchette",
          small: "< 50 000 $",
          medium: "50 000 $ — 200 000 $",
          large: "200 000 $ — 1 000 000 $",
          enterprise: "> 1 000 000 $",
        },
        timeline: "Délai souhaité",
        timeline_options: {
          placeholder: "Sélectionner un délai",
          urgent: "< 3 mois",
          short: "3 — 6 mois",
          medium: "6 — 12 mois",
          long: "> 12 mois",
        },
        message: "Description du projet",
        submit: "Envoyer la demande",
        sending: "Envoi en cours...",
        success: "Demande envoyée avec succès ! Notre équipe vous contactera sous 48h.",
        error: "Erreur lors de l'envoi. Veuillez réessayer ou nous contacter par téléphone.",
      },
      info: {
        phone: "Téléphone",
        email: "Email",
        address: "Siège Social",
        hours: "Heures d'ouverture",
        hours_value: "Lun — Ven : 8h00 — 17h00",
        address_full: "Avenue Lumumba, Commune de Kananga\nProvince du Kasaï-Central, RDC",
      },
    },
    footer: {
      banking: {
        title: "Informations Bancaires",
        bank: "Banque",
        account_name: "Intitulé du compte",
        account_number: "Numéro de compte",
      },
      rights: "Tous droits réservés",
      tagline: "L'excellence en ingénierie au cœur de l'Afrique",
    },
  },
  en: {
    nav: {
      home: "Home",
      about: "About",
      services: "Services",
      projects: "Projects",
      gallery: "Gallery",
      news: "News",
      blog: "Blog",
      partners: "Partners",
      contact: "Contact",
    },
    partners_section: {
      title: "Our Partners",
      subtitle: "Strong collaborations with leading institutions",
    },
    hero: {
      overline: "Engineering — Construction — Consulting",
      slogan: "Engineering excellence at the service of your ambitions",
      subtext: "Design, construction and supervision of critical infrastructure in the Democratic Republic of Congo. Civil engineering, hydraulic drilling, electrification and technical consulting to international standards.",
      cta_services: "Discover our services",
      cta_contact: "Request a quote",
      stats: {
        projects: "Projects delivered",
        experience: "Years of experience",
        engineers: "Engineers & technicians",
        provinces: "Provinces covered",
      },
    },
    about: {
      title: "About Us",
      subtitle: "Since 2009, building tomorrow's infrastructure",
      history: {
        title: "Our Story",
        p1: "Founded in 2009 in Kananga, JKM Engineering Sarl was born from the vision of Congolese engineers determined to deliver world-class technical solutions across the national territory. What began as a specialized civil engineering consultancy quickly grew into one of the DRC's most comprehensive engineering firms.",
        p2: "In 15 years, we have delivered over 50 major projects — from bridges to water supply networks, institutional buildings to drainage systems — spanning the entire Congolese territory. Our growth is built on a simple principle: every project is an opportunity to demonstrate that local expertise can match international standards.",
      },
      mission: {
        title: "Mission",
        text: "To design and deliver sustainable infrastructure that transforms living conditions for Congolese communities, combining cutting-edge technical expertise, technological innovation and commitment to operational excellence.",
      },
      vision: {
        title: "Vision",
        text: "To become the engineering partner of reference in Central Africa, recognized for the impeccable quality of our structures, our capacity for innovation and our measurable impact on continental infrastructure development.",
      },
      values: {
        title: "Our Values",
        quality: "Excellence",
        quality_desc: "ISO 9001 standards applied at every project phase, from sizing to final acceptance",
        innovation: "Innovation",
        innovation_desc: "Integration of modern technologies — survey drones, BIM, advanced geotechnical analysis",
        reliability: "Reliability",
        reliability_desc: "Systematic adherence to contractual deadlines with a 94% on-time delivery rate",
        integrity: "Integrity",
        integrity_desc: "Transparent governance, regular stakeholder reporting, full regulatory compliance",
      },
      team: {
        title: "Leadership Team",
        members: [
          { name: "Ir. Jean-Kasongo Mutombo", role: "Managing Director & Principal Engineer", desc: "Civil Engineer (University of Kinshasa), 20+ years in civil engineering and major project management" },
          { name: "Ir. Patrick Kalombo", role: "Technical Director", desc: "Specialist in hydrogeology and deep drilling, IWRA certified" },
          { name: "Ir. Marie Tshilumba", role: "Quality & HSE Manager", desc: "Quality Engineer certified ISO 9001:2015 & ISO 45001, expert in integrated management systems" },
        ],
      },
      certifications: {
        title: "Certifications & Standards",
        items: ["ISO 9001:2015 — Quality Management System", "ISO 45001:2018 — Occupational Health & Safety", "Eurocodes — Structural Design", "ASTM International — Material Testing", "RCCM: CD/KGA/RCCM/24-B-00015"],
      },
      methodology: {
        title: "Work Methodology",
        steps: [
          { step: "01", title: "Preliminary Studies", desc: "Site reconnaissance, feasibility study, geotechnical analysis" },
          { step: "02", title: "Design & Sizing", desc: "Technical drawings, structural calculations (Eurocodes), BIM modeling" },
          { step: "03", title: "Execution & Supervision", desc: "Site management, permanent quality control, weekly reporting" },
          { step: "04", title: "Acceptance & Follow-up", desc: "Compliance testing, client training, post-delivery warranty" },
        ],
      },
      legal: {
        title: "Legal Information",
        address: "Address",
        rccm: "RCCM",
        national_id: "National ID",
        tax_number: "Tax Number",
      },
    },
    services: {
      title: "Our Services",
      subtitle: "Integrated engineering solutions to international standards",
      intro: "Six areas of expertise covering the full lifecycle of your infrastructure projects, from design to maintenance.",
      civil: {
        title: "Civil Engineering & Structures",
        desc: "Design and construction of reinforced concrete structures, steel frames and civil works compliant with Eurocodes and ACI 318 standards.",
        items: ["Institutional and residential buildings", "Bridges and civil works", "Retaining walls and gabions", "Roads and urban roadways", "Drainage structures and culverts"],
        standards: "Eurocodes, ACI 318, NF EN 1992",
        process: "Geotechnical studies → Sizing → Execution plans → Construction → Quality control → Acceptance",
      },
      electrical: {
        title: "Electrical Engineering & Energy",
        desc: "Electrical system installation and renewable energy solutions for remote sites and buildings — photovoltaic solar kits, low/medium voltage distribution.",
        items: ["Photovoltaic solar systems (off-grid & hybrid)", "Low and medium voltage electrical distribution", "Public lighting and signalization", "Generator sets and inverters", "Energy audit and optimization"],
        standards: "IEC 60364, NF C 15-100, IEEE",
        process: "Energy audit → Sizing → Procurement → Installation → Testing & commissioning",
      },
      topography: {
        title: "Topography & Geomatics",
        desc: "Precision topographic surveys by GPS RTK and drone, digital terrain modeling (DTM), GIS mapping for infrastructure planning.",
        items: ["GPS RTK topographic surveys", "Drone photogrammetry", "Digital Terrain Models (DTM/DSM)", "GIS mapping and cadastral plans", "Site layout and staking"],
        standards: "ISO 19111, GNSS RTK, WGS 84",
        process: "Reconnaissance → Data acquisition → Processing → Modeling → Plan delivery",
      },
      drilling: {
        title: "Drilling & Hydraulics",
        desc: "Deep drilling (up to 250 m) for drinking water supply to rural and peri-urban communities, with solar pumping and sustainable water resource management.",
        items: ["Rotary drilling and down-the-hole hammer (DTH)", "Pump testing and aquifer characterization", "Solar pumping equipment", "Drinking water supply networks", "Village and peri-urban hydraulics"],
        standards: "ISO 22475, ASTM D5092, WHO Drinking Water Standards",
        process: "Hydrogeological study → Siting → Drilling → Pump testing → Equipment → Commissioning",
      },
      construction: {
        title: "Construction & Building",
        desc: "Turnkey construction project delivery — from earthworks to finishing — with rigorous cost, schedule and quality management following FIDIC best practices.",
        items: ["Turnkey building construction", "Earthworks and foundation works", "Interlocking paver and surfacing", "Landscaping and green spaces", "Structural rehabilitation and renovation"],
        standards: "FIDIC, DTU, NV 65 Rules",
        process: "Preliminary design → Execution plans → Procurement → Construction → QC → Provisional acceptance → Final acceptance",
      },
      consulting: {
        title: "Consulting & Project Management",
        desc: "Technical and strategic support for project owners — feasibility studies, technical bid preparation, site supervision and post-project evaluation.",
        items: ["Technical and economic feasibility studies", "Technical bid document preparation", "Project management and site supervision", "Technical audits and structural diagnostics", "Training and skills transfer"],
        standards: "FIDIC, PMI/PMBOK, Prince2",
        process: "Scoping → Diagnostic → Recommendations → Action plan → Implementation → Evaluation",
      },
    },
    projects: {
      title: "Our Projects",
      subtitle: "A portfolio of infrastructure projects demonstrating our expertise",
      view_details: "View details",
      budget: "Budget",
      duration: "Duration",
      tech: "Technologies",
      challenge: "Technical challenge",
      result: "Result",
    },
    gallery: {
      label: "Gallery",
      title: "Our Sites in Images",
      subtitle: "Photographic documentation of our field achievements. Click to enlarge.",
    },
    news: {
      title: "News",
      subtitle: "The latest advances from JKM Engineering in the DRC",
      read_more: "Read more",
      all_news: "All news",
      latest: "Latest",
    },
    blog: {
      title: "Technical Blog",
      subtitle: "In-depth analysis and reflections on engineering in Africa",
      read_more: "Read full article",
    },
    why: {
      title: "Why JKM Engineering",
      subtitle: "Excellence that makes the difference",
      experience: "Years of experience",
      projects: "Projects delivered",
      clients: "Client satisfaction",
      partners: {
        title: "Our Partners",
        desc: "We collaborate with leading institutions",
      },
    },
    testimonials: {
      title: "Testimonials",
      subtitle: "What our clients and partners say",
    },
    contact: {
      title: "Contact Us",
      subtitle: "Let's discuss your next infrastructure project",
      form: {
        name: "Full name",
        email: "Professional email",
        phone: "Phone",
        company: "Organization / Company",
        service: "Desired service",
        service_options: {
          placeholder: "Select a service",
          civil: "Civil Engineering & Structures",
          electrical: "Electrical Engineering & Energy",
          topography: "Topography & Geomatics",
          drilling: "Drilling & Hydraulics",
          construction: "Construction & Building",
          consulting: "Consulting & Project Management",
        },
        budget: "Estimated budget (USD)",
        budget_options: {
          placeholder: "Select a range",
          small: "< $50,000",
          medium: "$50,000 — $200,000",
          large: "$200,000 — $1,000,000",
          enterprise: "> $1,000,000",
        },
        timeline: "Desired timeline",
        timeline_options: {
          placeholder: "Select a timeline",
          urgent: "< 3 months",
          short: "3 — 6 months",
          medium: "6 — 12 months",
          long: "> 12 months",
        },
        message: "Project description",
        submit: "Submit request",
        sending: "Sending...",
        success: "Request sent successfully! Our team will contact you within 48 hours.",
        error: "Error sending request. Please try again or contact us by phone.",
      },
      info: {
        phone: "Phone",
        email: "Email",
        address: "Head Office",
        hours: "Business Hours",
        hours_value: "Mon — Fri: 8:00 AM — 5:00 PM",
        address_full: "Avenue Lumumba, Commune de Kananga\nKasai-Central Province, DRC",
      },
    },
    footer: {
      banking: {
        title: "Banking Information",
        bank: "Bank",
        account_name: "Account Name",
        account_number: "Account Number",
      },
      rights: "All rights reserved",
      tagline: "Engineering excellence in the heart of Africa",
    },
  },
};

export const companyInfo = {
  name: "JKM Engineering Sarl",
  address: "Avenue Lumumba, Commune de Kananga, Kasaï-Central, RDC",
  rccm: "CD/KGA/RCCM/24-B-00015",
  nationalId: "15-F4200-N58833K",
  taxNumber: "A2409270D",
  phones: ["+243 816107112", "+243 973239273"],
  email: "contact@jkmengineer.com",
  emailTeam: "junior.kayila@jkmengineer.com",
  bank: {
    name: "TMB",
    accountName: "JKM ENGINEERING Sarl",
    accountNumber: "00017-23000-10013458745/USD",
  },
  stats: {
    experience: 15,
    projects: 50,
    clients: 100,
    engineers: 35,
    provinces: 12,
  },
  partners: ["BCC Kananga", "PAF", "Gouvernement Provincial du Kasa\u00ef-Central", "Partenaires Priv\u00e9s"],
  logo: "https://customer-assets.emergentagent.com/job_0d77d791-1090-4f5a-a5b4-c78945c5298b/artifacts/15w8h7qo_logo.jpeg",
};
